import React from "react";
import "./Turntable_Activity_Rules.css";
import Rules_card from "../../Common/Common_Component/Rules_card/Rules_card";
import Common_white_header from "../../Common/Common_Component/Common_white_header/Common_white_header";

function Turntable_Activity_Rules() {
  return (
    <>
      <section className="Vip_Rules">
        <Common_white_header headingText={"Activity Rules"} />
        <div className="container">
          {/* List of Rules Cards */}
          {[1, 2, 3, 4, 5].map((item) => (
            <Rules_card key={item} />
          ))}
        </div>
      </section>
    </>
  );
}

export default Turntable_Activity_Rules;
